// Helpers
import { getPayPlansEditAccess } from "@/Common/helpers/Positions/positionsAccess";

// API's
// Technicians Queries
import {
	getTechnicianPayPlan,
	getTechnicianPayPlans,
	getTechnicianPayPlanMatches,
	getTechnicianPayPlansSidebarTree,
} from "@/PayPlans/api/technicians/queries";

// Technicians Mutations
import {
	createTechnicianPayPlan,
	saveNewTechnicianPayPlan,
	cloneTechnicianPayPlan,
	updateTechnicianPayPlan,
	updateTechnicianAvailablePayPlan,
	deleteTechnicianPayPlan,
} from "@/PayPlans/api/technicians/mutations";

// Technicians Subscriptions
import {
	onCloneTechnicianPayPlan,
	onCreateTechnicianPayPlan,
	onDeleteTechnicianPayPlan,
	onUpdateTechnicianPayPlan,
	onUpdateTechnicianAvailablePayPlan,
} from "@/PayPlans/api/technicians/subscriptions";

const getTechnicianEditAccess = (position) => getPayPlansEditAccess(position);

const getTechniciansServices = (position) => {
	// Auth actions
	const actions = {
		editable: getTechnicianEditAccess(position),
	};

	const getPayPlan = async (locationId, id, extraPosition) => getTechnicianPayPlan(locationId, id, extraPosition || position);
	const getMatches = async (locationId, id, extraPosition) => getTechnicianPayPlanMatches(locationId, id, extraPosition || position);

	// API Queries
	const queries = {
		getPayPlan,
		getMatches,
		getPayPlans: getTechnicianPayPlans,
		getPayPlansSidebarTree: getTechnicianPayPlansSidebarTree,
	};

	// API Mutations
	const mutations = {
		addPayPlan: createTechnicianPayPlan,
		saveNewPayPlan: saveNewTechnicianPayPlan,
		updatePayPlan: updateTechnicianPayPlan,
		deletePayPlan: deleteTechnicianPayPlan,
		clonePayPlan: cloneTechnicianPayPlan,
		updateAvailablePayPlan: updateTechnicianAvailablePayPlan,
	};

	// API Subscriptions
	const subscriptions = new Map([
		["onClonePayPlan", { query: onCloneTechnicianPayPlan, getter: "onCloneTechnicianPayPlan" }],
		["onCreatePayPlan", { query: onCreateTechnicianPayPlan, getter: "onCreateTechnicianPayPlan" }],
		["onDeletePayPlan", { query: onDeleteTechnicianPayPlan, getter: "onDeleteTechnicianPayPlan" }],
		["onUpdatePayPlan", { query: onUpdateTechnicianPayPlan, getter: "onUpdateTechnicianPayPlan" }],
		["onUpdateAnyPayPlan", { query: "", getter: "" }],
		["onUpdateAvailablePayPlan", { query: onUpdateTechnicianAvailablePayPlan, getter: "onUpdateTechnicianAvailablePayPlan" }],
	]);

	return {
		actions,
		queries,
		mutations,
		subscriptions,
	};
};

export { getTechniciansServices };
